/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseCompany } from '../models/api-response-company';
import { ApiResponseListPhoneCompany } from '../models/api-response-list-phone-company';
import { ApiResponseListWhatsAppConfig } from '../models/api-response-list-whats-app-config';
import { ApiResponseLocalDateTime } from '../models/api-response-local-date-time';
import { ApiResponseMessagingLimit } from '../models/api-response-messaging-limit';
import { ApiResponseProfileData } from '../models/api-response-profile-data';
import { ApiResponseSetString } from '../models/api-response-set-string';
import { ApiResponseString } from '../models/api-response-string';
import { ApiResponseWhatsAppConfig } from '../models/api-response-whats-app-config';
import { companyNumbersList } from '../fn/company-api/company-numbers-list';
import { CompanyNumbersList$Params } from '../fn/company-api/company-numbers-list';
import { deleteCompanyLogo } from '../fn/company-api/delete-company-logo';
import { DeleteCompanyLogo$Params } from '../fn/company-api/delete-company-logo';
import { getActivity } from '../fn/company-api/get-activity';
import { GetActivity$Params } from '../fn/company-api/get-activity';
import { getCompanyByCompanyId } from '../fn/company-api/get-company-by-company-id';
import { GetCompanyByCompanyId$Params } from '../fn/company-api/get-company-by-company-id';
import { getCompanyLogo } from '../fn/company-api/get-company-logo';
import { GetCompanyLogo$Params } from '../fn/company-api/get-company-logo';
import { getCompanyWaProfile } from '../fn/company-api/get-company-wa-profile';
import { GetCompanyWaProfile$Params } from '../fn/company-api/get-company-wa-profile';
import { getCompanyWaProfileImage1 } from '../fn/company-api/get-company-wa-profile-image-1';
import { GetCompanyWaProfileImage1$Params } from '../fn/company-api/get-company-wa-profile-image-1';
import { getLastLogin } from '../fn/company-api/get-last-login';
import { GetLastLogin$Params } from '../fn/company-api/get-last-login';
import { getListWhatsAppConfigByCompanyId } from '../fn/company-api/get-list-whats-app-config-by-company-id';
import { GetListWhatsAppConfigByCompanyId$Params } from '../fn/company-api/get-list-whats-app-config-by-company-id';
import { getMessagingLimit } from '../fn/company-api/get-messaging-limit';
import { GetMessagingLimit$Params } from '../fn/company-api/get-messaging-limit';
import { getWhatsAppConfigByPhone } from '../fn/company-api/get-whats-app-config-by-phone';
import { GetWhatsAppConfigByPhone$Params } from '../fn/company-api/get-whats-app-config-by-phone';
import { patchActivity } from '../fn/company-api/patch-activity';
import { PatchActivity$Params } from '../fn/company-api/patch-activity';
import { patchArchiveStatusByWabaPhoneIdentifier } from '../fn/company-api/patch-archive-status-by-waba-phone-identifier';
import { PatchArchiveStatusByWabaPhoneIdentifier$Params } from '../fn/company-api/patch-archive-status-by-waba-phone-identifier';
import { updateCompany } from '../fn/company-api/update-company';
import { UpdateCompany$Params } from '../fn/company-api/update-company';
import { updateCompanyEmails } from '../fn/company-api/update-company-emails';
import { UpdateCompanyEmails$Params } from '../fn/company-api/update-company-emails';
import { updateCompanyLogo } from '../fn/company-api/update-company-logo';
import { UpdateCompanyLogo$Params } from '../fn/company-api/update-company-logo';
import { updateCompanyWaProfile } from '../fn/company-api/update-company-wa-profile';
import { UpdateCompanyWaProfile$Params } from '../fn/company-api/update-company-wa-profile';
import { updateLastLogin } from '../fn/company-api/update-last-login';
import { UpdateLastLogin$Params } from '../fn/company-api/update-last-login';
import { updatePhoneLabel } from '../fn/company-api/update-phone-label';
import { UpdatePhoneLabel$Params } from '../fn/company-api/update-phone-label';

@Injectable({ providedIn: 'root' })
export class CompanyApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCompanyByCompanyId()` */
  static readonly GetCompanyByCompanyIdPath = '/v1/api/ui/company';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyByCompanyId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyByCompanyId$Response(params: GetCompanyByCompanyId$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseCompany>> {
    return getCompanyByCompanyId(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanyByCompanyId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyByCompanyId(params: GetCompanyByCompanyId$Params, context?: HttpContext): Observable<ApiResponseCompany> {
    return this.getCompanyByCompanyId$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseCompany>): ApiResponseCompany => r.body)
    );
  }

  /** Path part for operation `updateCompany()` */
  static readonly UpdateCompanyPath = '/v1/api/ui/company';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCompany()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateCompany$Response(params: UpdateCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseCompany>> {
    return updateCompany(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCompany$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateCompany(params: UpdateCompany$Params, context?: HttpContext): Observable<ApiResponseCompany> {
    return this.updateCompany$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseCompany>): ApiResponseCompany => r.body)
    );
  }

  /** Path part for operation `updateCompanyWaProfile()` */
  static readonly UpdateCompanyWaProfilePath = '/v1/api/ui/company/{wabaPhoneId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCompanyWaProfile()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateCompanyWaProfile$Response(params: UpdateCompanyWaProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseProfileData>> {
    return updateCompanyWaProfile(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCompanyWaProfile$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateCompanyWaProfile(params: UpdateCompanyWaProfile$Params, context?: HttpContext): Observable<ApiResponseProfileData> {
    return this.updateCompanyWaProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseProfileData>): ApiResponseProfileData => r.body)
    );
  }

  /** Path part for operation `updateCompanyLogo()` */
  static readonly UpdateCompanyLogoPath = '/v1/api/ui/company/{ref}/logo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCompanyLogo()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateCompanyLogo$Response(params: UpdateCompanyLogo$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseCompany>> {
    return updateCompanyLogo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCompanyLogo$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateCompanyLogo(params: UpdateCompanyLogo$Params, context?: HttpContext): Observable<ApiResponseCompany> {
    return this.updateCompanyLogo$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseCompany>): ApiResponseCompany => r.body)
    );
  }

  /** Path part for operation `deleteCompanyLogo()` */
  static readonly DeleteCompanyLogoPath = '/v1/api/ui/company/{ref}/logo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteCompanyLogo()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCompanyLogo$Response(params: DeleteCompanyLogo$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteCompanyLogo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteCompanyLogo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCompanyLogo(params: DeleteCompanyLogo$Params, context?: HttpContext): Observable<void> {
    return this.deleteCompanyLogo$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateCompanyEmails()` */
  static readonly UpdateCompanyEmailsPath = '/v1/api/ui/company/update-emails';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCompanyEmails()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCompanyEmails$Response(params: UpdateCompanyEmails$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseSetString>> {
    return updateCompanyEmails(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCompanyEmails$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCompanyEmails(params: UpdateCompanyEmails$Params, context?: HttpContext): Observable<ApiResponseSetString> {
    return this.updateCompanyEmails$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseSetString>): ApiResponseSetString => r.body)
    );
  }

  /** Path part for operation `updateLastLogin()` */
  static readonly UpdateLastLoginPath = '/v1/api/ui/company/update/last-login/{keycloakId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateLastLogin()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateLastLogin$Response(params: UpdateLastLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateLastLogin(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateLastLogin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateLastLogin(params: UpdateLastLogin$Params, context?: HttpContext): Observable<void> {
    return this.updateLastLogin$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updatePhoneLabel()` */
  static readonly UpdatePhoneLabelPath = '/v1/api/ui/company/number/{id}/label';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePhoneLabel()` instead.
   *
   * This method doesn't expect any request body.
   */
  updatePhoneLabel$Response(params: UpdatePhoneLabel$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updatePhoneLabel(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePhoneLabel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  updatePhoneLabel(params: UpdatePhoneLabel$Params, context?: HttpContext): Observable<void> {
    return this.updatePhoneLabel$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `patchArchiveStatusByWabaPhoneIdentifier()` */
  static readonly PatchArchiveStatusByWabaPhoneIdentifierPath = '/v1/api/ui/company/archive/{wabaPhoneIdentifier}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchArchiveStatusByWabaPhoneIdentifier()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchArchiveStatusByWabaPhoneIdentifier$Response(params: PatchArchiveStatusByWabaPhoneIdentifier$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return patchArchiveStatusByWabaPhoneIdentifier(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchArchiveStatusByWabaPhoneIdentifier$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchArchiveStatusByWabaPhoneIdentifier(params: PatchArchiveStatusByWabaPhoneIdentifier$Params, context?: HttpContext): Observable<void> {
    return this.patchArchiveStatusByWabaPhoneIdentifier$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `patchActivity()` */
  static readonly PatchActivityPath = '/v1/api/ui/company/activity/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchActivity()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchActivity$Response(params: PatchActivity$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return patchActivity(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchActivity$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchActivity(params: PatchActivity$Params, context?: HttpContext): Observable<void> {
    return this.patchActivity$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getCompanyWaProfile()` */
  static readonly GetCompanyWaProfilePath = '/v1/api/ui/company/wa-profile/{wabaPhoneId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyWaProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyWaProfile$Response(params: GetCompanyWaProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseProfileData>> {
    return getCompanyWaProfile(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanyWaProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyWaProfile(params: GetCompanyWaProfile$Params, context?: HttpContext): Observable<ApiResponseProfileData> {
    return this.getCompanyWaProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseProfileData>): ApiResponseProfileData => r.body)
    );
  }

  /** Path part for operation `getCompanyWaProfileImage1()` */
  static readonly GetCompanyWaProfileImage1Path = '/v1/api/ui/company/wa-profile/{wabaPhoneId}/image';

  /**
   * Get WhatsApp profile image.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyWaProfileImage1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyWaProfileImage1$Response(params: GetCompanyWaProfileImage1$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return getCompanyWaProfileImage1(this.http, this.rootUrl, params, context);
  }

  /**
   * Get WhatsApp profile image.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanyWaProfileImage1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyWaProfileImage1(params: GetCompanyWaProfileImage1$Params, context?: HttpContext): Observable<Blob> {
    return this.getCompanyWaProfileImage1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `companyNumbersList()` */
  static readonly CompanyNumbersListPath = '/v1/api/ui/company/numbers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companyNumbersList()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyNumbersList$Response(params: CompanyNumbersList$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListPhoneCompany>> {
    return companyNumbersList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `companyNumbersList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyNumbersList(params: CompanyNumbersList$Params, context?: HttpContext): Observable<ApiResponseListPhoneCompany> {
    return this.companyNumbersList$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListPhoneCompany>): ApiResponseListPhoneCompany => r.body)
    );
  }

  /** Path part for operation `getMessagingLimit()` */
  static readonly GetMessagingLimitPath = '/v1/api/ui/company/numbers/{phoneReference}/messaging-limit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMessagingLimit()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMessagingLimit$Response(params: GetMessagingLimit$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseMessagingLimit>> {
    return getMessagingLimit(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMessagingLimit$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMessagingLimit(params: GetMessagingLimit$Params, context?: HttpContext): Observable<ApiResponseMessagingLimit> {
    return this.getMessagingLimit$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseMessagingLimit>): ApiResponseMessagingLimit => r.body)
    );
  }

  /** Path part for operation `getCompanyLogo()` */
  static readonly GetCompanyLogoPath = '/v1/api/ui/company/media';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyLogo()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyLogo$Response(params?: GetCompanyLogo$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return getCompanyLogo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanyLogo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyLogo(params?: GetCompanyLogo$Params, context?: HttpContext): Observable<string> {
    return this.getCompanyLogo$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `getLastLogin()` */
  static readonly GetLastLoginPath = '/v1/api/ui/company/last-login/{companyId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLastLogin()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLastLogin$Response(params: GetLastLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseLocalDateTime>> {
    return getLastLogin(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLastLogin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLastLogin(params: GetLastLogin$Params, context?: HttpContext): Observable<ApiResponseLocalDateTime> {
    return this.getLastLogin$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseLocalDateTime>): ApiResponseLocalDateTime => r.body)
    );
  }

  /** Path part for operation `getListWhatsAppConfigByCompanyId()` */
  static readonly GetListWhatsAppConfigByCompanyIdPath = '/v1/api/ui/company/config';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getListWhatsAppConfigByCompanyId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getListWhatsAppConfigByCompanyId$Response(params: GetListWhatsAppConfigByCompanyId$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListWhatsAppConfig>> {
    return getListWhatsAppConfigByCompanyId(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getListWhatsAppConfigByCompanyId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getListWhatsAppConfigByCompanyId(params: GetListWhatsAppConfigByCompanyId$Params, context?: HttpContext): Observable<ApiResponseListWhatsAppConfig> {
    return this.getListWhatsAppConfigByCompanyId$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListWhatsAppConfig>): ApiResponseListWhatsAppConfig => r.body)
    );
  }

  /** Path part for operation `getWhatsAppConfigByPhone()` */
  static readonly GetWhatsAppConfigByPhonePath = '/v1/api/ui/company/config/{phoneReference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWhatsAppConfigByPhone()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWhatsAppConfigByPhone$Response(params: GetWhatsAppConfigByPhone$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseWhatsAppConfig>> {
    return getWhatsAppConfigByPhone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWhatsAppConfigByPhone$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWhatsAppConfigByPhone(params: GetWhatsAppConfigByPhone$Params, context?: HttpContext): Observable<ApiResponseWhatsAppConfig> {
    return this.getWhatsAppConfigByPhone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseWhatsAppConfig>): ApiResponseWhatsAppConfig => r.body)
    );
  }

  /** Path part for operation `getActivity()` */
  static readonly GetActivityPath = '/v1/api/ui/company/activity/{companyId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getActivity()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActivity$Response(params: GetActivity$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseString>> {
    return getActivity(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getActivity$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActivity(params: GetActivity$Params, context?: HttpContext): Observable<ApiResponseString> {
    return this.getActivity$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseString>): ApiResponseString => r.body)
    );
  }

}
